import React from 'react';
import { prodIcon0, prodIcon1, prodIcon2, prodIcon3 } from '../../assets/icons';
import './style.less';

const USE_CASES = [
  {
    icon: prodIcon2,
    tag: '外包与供应链治理',
    title: '集团外包与联合研发安全管控',
    pain: '外包人员流动性大、自备终端不可控，传统发放源码包极易造成核心资产外泄。',
    solution:
      '按项目边界分配限期工作间，开启「禁止下载 + 禁止复制 + 禁用本地 SSH + 强制动态水印」，到期自动撤权断连并移交存储卷资产。',
    outcome: '代码可用不可带走 · 退场零残留',
  },
  {
    icon: prodIcon1,
    tag: '纯内网 Air-Gapped',
    title: '涉密与内网离线研发环境建设',
    pain: '金融、政企与军工内网完全隔离互联网，无法拉取公网容器镜像、IDE 插件与构建依赖。',
    solution:
      '通过 Ed25519 签名离线安装包交付，内置 Harbor 镜像仓库、.gcpb 签名插件包与离线漏洞库，全面对接内网 apt / pip / npm / Maven / Go 源。',
    outcome: '100% 离线闭环 · 零外网依赖',
  },
  {
    icon: prodIcon0,
    tag: '私有大模型赋能',
    title: '企业私有化 AI 辅助编程落地',
    pain: '公网 AI 编程助手存在源码出境风险，自建开源大模型又难以与研发工具链统一打通。',
    solution:
      '工作间开箱内置 Codex 与 Steerable，经平台模型网关统一接入企业内网 DeepSeek / Qwen / vLLM，上游密钥隔离于控制面。',
    outcome: '密钥不落地 · 额度与提问可审计',
  },
  {
    icon: prodIcon3,
    tag: '工程效能标准化',
    title: '多语言复杂工程与千人环境统一',
    pain: '微服务或多语言工程本地配环境耗时长达数天，“我本地是好的”环境差异频发。',
    solution:
      '项目负责人通过共享模板一键锁定镜像 digest、CPU/内存/磁盘规格与白名单插件，配合节点 DaemonSet 预热实现即开即用。',
    outcome: '新人 10 秒上手 · 环境 100% 一致',
  },
];

const UseCases = () => {
  return (
    <div className="use-cases">
      {USE_CASES.map((item) => (
        <article key={item.title} className="use-case-card cloud-collab-card">
          <div className="case-top">
            <div className="use-case-icon">
              <img src={item.icon} alt="" aria-hidden="true" />
            </div>
            <span className="case-tag">{item.tag}</span>
          </div>

          <h3>{item.title}</h3>

          <div className="case-block pain">
            <span className="block-label">核心痛点</span>
            <p>{item.pain}</p>
          </div>

          <div className="case-block solution">
            <span className="block-label">平台方案</span>
            <p>{item.solution}</p>
          </div>

          <div className="case-outcome">
            <span className="outcome-dot" aria-hidden="true" />
            <span>{item.outcome}</span>
          </div>
        </article>
      ))}
    </div>
  );
};

export default UseCases;
